import * as http from './base'

// 文章基本信息
export const getArticleDetail = (params) => {
  return http.fetch('/cms/api/article/detail', params)
}

// 文章列表
export const getArticleList  = (data) => {
  return http.post('/cms/api/article/list', data)
}

// banner 列表
export const getBannerList = (data) => {
  return http.post('/cms/api/banner/list', data)
}

// 分类列表字典
export const getCategoryList = (params) => {
  return http.fetch('/cms/api/category/list', params)
}

//
export const saveConsult = (data) => {
  return http.post('/cms/api/consult/save', data)
}




// WEBPACK FOOTER //
// ./src/http/home.js